<alert></alert>
<alert-timer #alertTimer></alert-timer>
<information></information>
<app-dialog #dialog></app-dialog>